const actions = {
  DONATION_CATEGORY_ADD_BEGIN: 'DONATION_CATEGORY_ADD_BEGIN',
  DONATION_CATEGORY_ADD_SUCCESS: 'DONATION_CATEGORY_ADD_SUCCESS',
  DONATION_CATEGORY_ADD_ERR: 'DONATION_CATEGORY_ADD_ERR',
  
  DONATION_CATEGORIES_READ_BEGIN: 'DONATION_CATEGORIES_READ_BEGIN',
  DONATION_CATEGORIES_READ_SUCCESS: 'DONATION_CATEGORIES_READ_SUCCESS',
  DONATION_CATEGORIES_READ_ERR: 'DONATION_CATEGORIES_READ_ERR',

  DONATION_CATEGORY_UPDATE_BEGIN: 'DONATION_CATEGORY_UPDATE_BEGIN',
  DONATION_CATEGORY_UPDATE_SUCCESS: 'DONATION_CATEGORY_UPDATE_SUCCESS',
  DONATION_CATEGORY_UPDATE_ERR: 'DONATION_CATEGORY_UPDATE_ERR',

  DONATION_CATEGORY_DELETE_BEGIN: 'DONATION_CATEGORY_DELETE_BEGIN',
  DONATION_CATEGORY_DELETE_SUCCESS: 'DONATION_CATEGORY_DELETE_SUCCESS',
  DONATION_CATEGORY_DELETE_ERR: 'DONATION_CATEGORY_DELETE_ERR',

  DONATION_CATEGORY_READ_BEGIN: 'DONATION_CATEGORY_READ_BEGIN',
  DONATION_CATEGORY_READ_SUCCESS: 'DONATION_CATEGORY_READ_SUCCESS',
  DONATION_CATEGORY_READ_ERR: 'DONATION_CATEGORY_READ_ERR',

  axiosReadBegin: () => {
    return {
      type: actions.DONATION_CATEGORIES_READ_BEGIN,
    };
  },

  axiosReadSuccess: data => {
    return {
      type: actions.DONATION_CATEGORIES_READ_SUCCESS,
      data,
    };
  },

  axiosReadErr: err => {
    return {
      type: actions.DONATION_CATEGORIES_READ_ERR,
      err,
    };
  },

  axiosAddBegin: () => {
    return {
      type: actions.DONATION_CATEGORY_ADD_BEGIN,
    };
  },

  axiosAddSuccess: data => {
    return {
      type: actions.DONATION_CATEGORY_ADD_SUCCESS,
      data,
    };
  },

  axiosAddErr: err => {
    return {
      type: actions.DONATION_CATEGORY_ADD_ERR,
      err,
    };
  },
  
  axiosUpdateBegin: () => {
    return {
      type: actions.DONATION_CATEGORY_UPDATE_BEGIN,
    };
  },

  axiosUpdateSuccess: data => {
    return {
      type: actions.DONATION_CATEGORY_UPDATE_SUCCESS,
      data,
    };
  },

  axiosUpdateErr: err => {
    return {
      type: actions.DONATION_CATEGORY_UPDATE_ERR,
      err,
    };
  },

  axiosDeleteBegin: () => {
    return {
      type: actions.DONATION_CATEGORY_DELETE_BEGIN,
    };
  },

  axiosDeleteSuccess: data => {
    return {
      type: actions.DONATION_CATEGORY_DELETE_SUCCESS,
      data,
    };
  },

  axiosDeleteErr: err => {
    return {
      type: actions.DONATION_CATEGORY_DELETE_ERR,
      err,
    };
  },

  axiosSingleDataBegin: () => {
    return {
      type: actions.DONATION_CATEGORY_READ_BEGIN,
    };
  },

  axiosSingleDataSuccess: data => {
    return {
      type: actions.DONATION_CATEGORY_READ_SUCCESS,
      data,
    };
  },

  axiosSingleDataErr: err => {
    return {
      type: actions.DONATION_CATEGORY_READ_ERR,
      err,
    };
  },

};

export default actions;
